import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["onSelect", "onChange"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import Collapse from './Collapse';
import Panel from './Panel';
import { Warning } from "../../wui-core/src";
var isShouldUpdate = Warning.isShouldUpdate;

var CollapseWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(CollapseWrapper, _React$Component);

  var _super = _createSuper(CollapseWrapper);

  function CollapseWrapper(props) {
    _classCallCheck(this, CollapseWrapper);

    return _super.call(this, props);
  }

  _createClass(CollapseWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onSelect = _this$props.onSelect,
          onChange = _this$props.onChange,
          others = _objectWithoutProperties(_this$props, _excluded);

      isShouldUpdate("Collapse", this.props);
      var extral = {
        onSelect: onChange ? onChange : onSelect
      };
      return /*#__PURE__*/React.createElement(Collapse, _extends({}, extral, others));
    }
  }]);

  return CollapseWrapper;
}(React.Component);

CollapseWrapper.Panel = Panel;
export default CollapseWrapper;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-collapse/src/index.js